module.exports = __webpack_public_path__ + "static/verein-von-der-frage-bis-zur-loesung-img-8a47b338c97b68bf1e6ce1563d9a5b61.jpg";